import React from 'react'
import { Slot } from 'radix-ui'

import { ampli } from '@/shared/lib/ampli'
import { useModals } from '@/shared/lib/modal-manager'

export const CopyPricingCampaign = ({
	pricingCampaignsIds,
	children,
}: {
	pricingCampaignsIds: string[]
	children: React.ReactNode
}) => {
	const { showModal } = useModals()
	const handleDublicatePricingCampaignsClick = () => {
		ampli.settingsPricingCampaignsTableDuplicatePCs()
		showModal('DUBLICATE_PRICING_CANPAIGNS_TO_OPTIMIZATION_GROUP', {
			selected: pricingCampaignsIds,
		})
	}

	return (
		<Slot.Root onClick={handleDublicatePricingCampaignsClick}>
			{children}
		</Slot.Root>
	)
}
